export enum Routes {
  ACCESS_TO_MEDICATION = 'rezept-anfragen',
  ACCESS_TO_MEDICATION_INSURANCE = ':insurance',

  ACCESS_TO_MEDICATION_NEW = 'rezept-anfragen',
  ACCESS_TO_MEDICATION_NEW_FAQ = 'rezept-anfragen/faq/:openDefaultItems?',
  ACCESS_TO_MEDICATION_NEW_PROVIDER = 'rezept-anfragen/anbieter',

  VIDEO_CONSULTATION = 'videosprechstunde-vereinbaren',
  VIDEO_CONSULTATION_INSURANCE = 'videosprechstunde-vereinbaren/:insurance',

  FEATURE_OVERVIEW = 'feature-overview',
  BRANCH_PREVIEW = 'branch-preview'
}

export function path(relative: string): string {
  const { pathname } = window.location;
  let prefix: string = pathname;

  // take all route bases from all possible routes (from Routes enum)
  const routeBases = Object.values(Routes).map(route => route.split('/')[0]);

  // find first routeBase that it is included inside pathname
  const routeBase = routeBases.find(routeBase => pathname.includes(routeBase));
  if (routeBase) {
    // take everything prior that routeBase and use it as root prefix
    // it will hold something like /custom/path/to/online/doctor/online-arzt-service/
    // (onto which relative path is appended to get full path)
    prefix = pathname.slice(0, pathname.indexOf(routeBase));
  }

  // append relative path, replace is legacy and probably not needed
  return `${prefix}${relative}`.replace('//', '');
}
